import { action, computed, observable, makeAutoObservable } from 'mobx';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

export class SelectNativeStateNew {
    @observable isOpen: boolean = false;

    constructor(
        private readonly stateValue: FormInputState<string, string> | FormInputState<string, number | null> | string,
        private readonly onChangeCB?: (value: string) => void
    ) {
        makeAutoObservable(this);
    }

    @action onChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const value = event.target.value;

        if (this.onChangeCB !== undefined) {
            this.onChangeCB(value);
        }

        if (typeof this.stateValue !== 'string') {
            this.stateValue.setValue(value);
        }

        this.isOpen = !this.isOpen;
    };

    @computed get errorMessage(): string | undefined {
        if (typeof this.stateValue !== 'string') {
            return this.stateValue.errorsForView?.[0];
        }
        return;
    }
}
